import Repository from "../../repository";

export default {
    Add: (payload) => Repository.post(`/api/GuestComments/Add`, payload),
    GetByOID: (payload) => Repository.post(`/api/GuestComments/GetByOID`, payload),
}
